export const    CLEAR_USER = "CLEAR_USER", 
                EDIT_USER = "EDIT_USER", 
                
                GET_MEMBER_REQUEST = "GET_MEMBER_REQUEST",
                GET_MEMBER_SUCCESS = "GET_MEMBER_SUCCESS",
                GET_MEMBER_FAILURE = "GET_MEMBER_FAILURE",

                SAVE_MEMBER_REQUEST = "SAVE_MEMBER_REQUEST",
                SAVE_MEMBER_SUCCESS = "SAVE_MEMBER_SUCCESS",
                SAVE_MEMBER_FAILURE = "SAVE_MEMBER_FAILURE",
                
                FOLLOW_POST_REQUEST = "FOLLOW_POST_REQUEST",
                FOLLOW_POST_SUCCESS = "FOLLOW_POST_SUCCESS",
                FOLLOW_POST_FAILURE = "FOLLOW_POST_FAILURE",

                SEARCH_MEMBER_REQUEST = "SEARCH_MEMBER_REQUEST",
                SEARCH_MEMBER_SUCCESS = "SEARCH_MEMBER_SUCCESS",
                SEARCH_MEMBER_FAILURE = "SEARCH_MEMBER_FAILURE",
                
                SET_NOTIFICATION_REQUEST = "SET_NOTIFICATION_REQUEST",
                SET_NOTIFICATION_SUCCESS = "SET_NOTIFICATION_SUCCESS",
                SET_NOTIFICATION_FAILURE = "SET_NOTIFICATION_FAILURE",
                
                SET_EMAIL_UPDATE_REQUEST = "SET_EMAIL_UPDATE_REQUEST",
                SET_EMAIL_UPDATE_SUCCESS = "SET_EMAIL_UPDATE_SUCCESS",
                SET_EMAIL_UPDATE_FAILURE = "SET_EMAIL_UPDATE_FAILURE";


                export function setUpdateFrequencyRequest(value) {
                    return {
                        type: SET_EMAIL_UPDATE_REQUEST,
                        value
                    };
                }
                
                export function setUpdateFrequencySuccess(value) {
                    return {
                        type: SET_EMAIL_UPDATE_SUCCESS,
                        value
                    };
                }
                
                export function setUpdateFrequencyFailure(responseStatus) {
                    return {
                        type: SET_EMAIL_UPDATE_FAILURE,
                        responseStatus
                    };
                }

export function setNotificationRequest(value) {
    return {
        type: SET_NOTIFICATION_REQUEST,
        value
    };
}

export function setNotificationSuccess(value) {
    return {
        type: SET_NOTIFICATION_SUCCESS,
        value
    };
}

export function setNotificationFailure(responseStatus) {
    return {
        type: SET_NOTIFICATION_FAILURE,
        responseStatus
    };
}


export function getMemberRequest(id) {
    return {
        type: GET_MEMBER_REQUEST,
        id
    };
}

export function getMemberSuccess(response) {
    return {
        type: GET_MEMBER_SUCCESS,
        member: response.member
    };
}

export function getMemberFailure(responseStatus) {
    return {
        type: GET_MEMBER_FAILURE,
        responseStatus
    };
}

/* Members */
export function saveMemberRequest(id, member) {
    return {
        type: SAVE_MEMBER_REQUEST,
        member,
        id
    };
}
export function saveMemberSuccess(response) {
    return {
        type: SAVE_MEMBER_SUCCESS,
        member: response.member
    };
}
export function saveMemberFailure(responseStatus) {
    return {
        type: SAVE_MEMBER_FAILURE,
        responseStatus
    };
}

export function searchMemberRequest(id, term) {
    return {
        type: SEARCH_MEMBER_REQUEST,
        id,
        term
    };
}

export function searchMemberSuccess(response) {
    return {
        type: SEARCH_MEMBER_SUCCESS,
        members: response.members
    };
}
export function searchMemberFailure(responseStatus) {
    return {
        type: SEARCH_MEMBER_FAILURE,
        responseStatus
    };
}

export function editUser(userId) {
    return {
        type: EDIT_USER,
        userId
    };
}
export function clearUser() {
    return {
        type: CLEAR_USER,
    };
}





// WEBPACK FOOTER //
// ./src/actions/members.actions.ts